import React from 'react'
import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'

export default props => (
  <div
    className={cn(sLay['layout-row'], sLay['layout-align-center-center'], props.className)}
    style={{ height: '10px' }}
  >
    {props.children}
  </div>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Dots/Dots/Dots.jsx